import { FunctionFactory } from "survey-core";
import { loc, tSurvey } from "../i18n/survey";

enum Gender {
  Male = "Male",
  Female = "Female",
  NonBinary = "Non-binary",
}


const genderQuestion = {
  name: "gender",
  title: loc("quiz.gender.title"),
  description: loc("quiz.gender.description"),
  descriptionLocation: 'underTitle',
  type: "radiogroup",
  choices: [
    { value: Gender.Male, text: loc("quiz.gender.choices.male") },
    { value: Gender.Female, text: loc("quiz.gender.choices.female") },
    { value: Gender.NonBinary, text: loc("quiz.gender.choices.nonBinary") },
  ],
  isRequired: true,
};

const genderNounExpression = {
  name: "genderNoun",
  expression: "renderGender({gender})",
};

function renderGender(params: any[]): string {
  if (params === undefined || params === null) return "";
  return (params[0] as Gender) === Gender.Female ? tSurvey("quiz.gender.noun.women") : tSurvey("quiz.gender.noun.men");
}

FunctionFactory.Instance.register("renderGender", renderGender);

export { Gender, genderNounExpression, genderQuestion, renderGender };
